import { supabase } from '@/core/database/supabase';
import type { CompanyMember } from '../types/company.types';

export const CompanyMembersService = {
  async getMembers(companyId: string): Promise<CompanyMember[]> {
    const { data, error } = await supabase
      .from('user_profiles')
      .select('*')
      .eq('company_id', companyId);

    if (error) throw error;
    
    return (data || []).map(p => ({
      id: p.id,
      full_name: p.full_name,
      email: p.email,
      role_code: p.role_code,
      avatar_path: p.avatar_path,
      joined_at: p.created_at,
      is_active: p.is_active ?? true
    }));
  },

  async inviteMember(companyId: string, email: string, roleCode: string) {
    // Logic for sending invitation
    // In a real app, this would call an Edge Function or insert into an invites table
    const { error } = await supabase
      .from('company_invitations')
      .insert([{
        company_id: companyId,
        email,
        role_code: roleCode,
        status: 'pending'
      }]);

    if (error) throw error;
  },

  async updateMemberRole(memberId: string, roleCode: string) {
    const { error } = await supabase
      .from('user_profiles')
      .update({ role_code: roleCode })
      .eq('id', memberId);

    if (error) throw error;
  },

  async removeMember(memberId: string) {
    const { error } = await supabase
      .from('user_profiles')
      .update({ company_id: null, role_code: 'user' }) // Soft remove or detach
      .eq('id', memberId);

    if (error) throw error;
  }
};
